import { render, staticRenderFns } from "./IntegrationMessageConfigList.vue?vue&type=template&id=73694d6c&"
import script from "./IntegrationMessageConfigList.vue?vue&type=script&lang=js&"
export * from "./IntegrationMessageConfigList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports